import { render, staticRenderFns } from "./unit_test_edit.vue?vue&type=template&id=5b33ae45&scoped=true&"
import script from "./unit_test_edit.vue?vue&type=script&lang=js&"
export * from "./unit_test_edit.vue?vue&type=script&lang=js&"
import style0 from "./unit_test_edit.vue?vue&type=style&index=0&id=5b33ae45&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b33ae45",
  null
  
)

export default component.exports